import styled from 'styled-components';
import React from 'react';
import Mailto from 'react-protected-mailto';
import { themeGet } from 'styled-system';

import Mail from '../fonts/mail.svg';

const EmailLinkWrapper = styled.div`
  align-items: center;
  justify-content: space-between;
  max-width: 230px;
  margin: 0 auto;
  &::before {
    content: url(${Mail});
    display: block;
    position: relative;
    width: 22px;
    left: 22px;
    top: 42px;
    z-index: 9;
  }
  .maillink-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    border-radius: 0px;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 7px 25px 0px rgba(22, 53, 76, 0.15);
    height: 50px;
    padding-left: 60px;
    opacity: 1;
    @media (max-width: 768px) {
    }
  }
  .mailto {
    color: ${themeGet('colors.primary')};
    font-weight: 400;
  }
`;


const EmailLink = ({
  email,
  subject,
  iconPosition,
  ...props
}) => {

  let mailElement;

  // Add all classs to an array
  const addAllClasses = ['reusecore__emaillink'];

  // Add icon position class if input element has icon
  if (iconPosition) {
    addAllClasses.push(`icon-${iconPosition}`);
  }

  mailElement = (
    <div className="maillink-wrapper">
      <Mailto className="mailto"
        {...props}
        email={email}
        headers={{subject:subject}}
      />
    </div>
  );

  return (
    <EmailLinkWrapper>
      {mailElement}
    </EmailLinkWrapper>
  );
};

export default EmailLink;
